/**
 * Chip — spec §F2 `Chip(kind: open|sensitive|restricted|provisional)`.
 * 9px uppercase access-class chip; colours come from the §F2 tokens via base.css.
 */
import type { ReactNode } from 'react';

/**
 * The four §F2 access classes, plus the two §M3 provenance chips the §F5.2 indicator
 * rows carry (`mels`/`demo`). They share the component because they share the shape —
 * a 9 px uppercase pill at the end of a list row — and giving provenance its own
 * near-identical component would let the two drift apart visually for no reason.
 */
export type ChipKind = 'open' | 'sensitive' | 'restricted' | 'provisional' | 'mels' | 'demo';

export interface ChipProps {
  kind: ChipKind;
  children?: ReactNode;
  title?: string;
}

const LABELS: Record<ChipKind, string> = {
  open: 'Open',
  sensitive: 'Sensitive',
  restricted: 'Restricted',
  provisional: 'Provisional',
  mels: 'MELS',
  demo: 'Demo',
};

export function Chip({ kind, children, title }: ChipProps) {
  return (
    <span className={`chip ${kind}`} title={title}>
      {children ?? LABELS[kind]}
    </span>
  );
}
